import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BaseGuardGuard } from './base-guard.guard';

@Injectable()
export class DriverGuard extends BaseGuardGuard {
  constructor(router: Router) {
    super(router, ['ewd-driver']);
  }
}
